import { useState } from "react";
import { useAuth } from "@/App";
import { useNavigate, Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, Mail, Loader2 } from "lucide-react";
import { ROLE_HOME } from "@/components/schulungen/roles";

const ICON_URL = "https://customer-assets.emergentagent.com/job_online-pflegekasse/artifacts/72f9n7x9_1775301634776.png";

export default function CRMLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={ROLE_HOME[user.role] || "/app"} replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(ROLE_HOME[u?.role] || "/app");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login fehlgeschlagen");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="crm-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="h-14 w-14 shrink-0 overflow-hidden mx-auto mb-4">
            <img src={ICON_URL} alt="Logo" className="h-full w-auto object-cover object-left scale-[2.3] origin-[15%_41%]" />
          </div>
          <h1 className="font-['Manrope'] text-2xl font-bold text-slate-900">Pflegeberatung CRM</h1>
          <p className="text-sm text-slate-500 mt-1">Pflegeberatung & Alltagsbegleitung</p>
        </div>
        <div className="bg-white rounded-2xl shadow-lg border border-slate-200/60 p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            {error && <div className="bg-red-50 text-red-700 text-sm p-3 rounded-xl border border-red-200" data-testid="login-error">{error}</div>}
            <div>
              <Label className="text-sm font-semibold text-slate-700 mb-1.5 block">E-Mail oder Benutzername</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                <Input data-testid="login-email" type="text" autoComplete="username" placeholder="E-Mail oder Benutzername" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 pl-10 rounded-xl" />
              </div>
            </div>
            <div>
              <Label className="text-sm font-semibold text-slate-700 mb-1.5 block">Passwort</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                <Input data-testid="login-password" type="password" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 pl-10 rounded-xl" />
              </div>
            </div>
            <Button type="submit" data-testid="login-submit-btn" disabled={loading} className="w-full bg-cyan-700 hover:bg-cyan-600 text-white rounded-xl h-12 text-base font-semibold">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Anmelden"}
            </Button>
          </form>
        </div>
        <p className="text-center text-xs text-slate-400 mt-6">
          <a href="/" className="hover:text-cyan-700 transition-colors">Zurück zur Website</a>
        </p>
      </div>
    </div>
  );
}
